import React, { ReactNode } from "react"
import {
  HStack,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightElement,
  Text,
} from "@chakra-ui/react"
import Menu from "components/dialogs/Menu"
import Icon from "components/elements/Icon"
import GlobeIcon from "components/elements/GlobeIcon"
import CopyIconButton from "components/elements/CopyIconButton"

type Props = {
  label: string
  url: string
  actions?: ReactNode[]
}

// "Page Link ▾ | https://… ⧉": the menu holds actions related to the link.
const LinkSelector = ({ label, url, actions = [] }: Props) => {
  const hasMenu = actions.length > 0

  const trigger = (
    <HStack spacing={2} h={9} px={4} fontWeight="semibold" color="gray.700">
      <GlobeIcon boxSize={4} color="gray.600" />
      <Text as="span" whiteSpace="nowrap">{label}</Text>
      {hasMenu && <Icon icon="down-arrow" size={3} color="gray.600" />}
    </HStack>
  )

  return (
    <InputGroup w="auto" minW={0}>
      <InputLeftAddon
        h={9}
        p={0}
        bg="gray.50"
        borderColor="gray.300"
        borderLeftRadius="full"
        overflow="hidden"
        _hover={hasMenu ? { bg: "gray.100" } : undefined}
      >
        {hasMenu ? (
          <Menu button={trigger} menuItems={actions} placement="bottom-start" noPadding />
        ) : trigger}
      </InputLeftAddon>
      <Input
        as="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        title={url}
        display="block"
        h={9}
        w="auto"
        maxW="xs"
        lineHeight="34px"
        pr={10}
        bg="white"
        borderColor="gray.300"
        borderRightRadius="full"
        color="blue.500"
        fontWeight="semibold"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        _hover={{ textDecoration: "underline", borderColor: "gray.400" }}
      >
        {url}
      </Input>
      <InputRightElement h={9}>
        <CopyIconButton key={url} text={url} borderRadius="full" />
      </InputRightElement>
    </InputGroup>
  )
}

export default LinkSelector
